import Chip from '@mui/material/Chip';
import { TaskStatus } from '../../../interfaces/eligibility';
import { StyledTheme } from '../../../styles/styleTheme';

export const ACEItemStatus = ({ status }: { status: TaskStatus }) => {
  const backgroundColor =
    status === TaskStatus.AutoCompleted ? StyledTheme.greenLightMui : StyledTheme.yellowLightMui;
  return <Chip label={status} sx={{ backgroundColor }} />;
};
